// extracted by css-extract-rspack-plugin
export default {"closeButton":"f24IB z4qKh"};